import { CardModel } from './Poker.CardModel';
import { SquareModel } from './Poker.SquareModel';
import { DeckModel } from './Poker.DeckModel';
import { OptionModel } from './Poker.OptionModel';
import { NumberFormatStyle } from '@angular/common';

class HandRow {
    squares: SquareModel[] = [new SquareModel(0,0,0), new SquareModel(0,0,0)
                            , new SquareModel(0,0,0), new SquareModel(0,0,0)
                            , new SquareModel(0,0,0), new SquareModel(0,0,0)];
}

export class HandModel {

    public handRows: HandRow[] = [new HandRow(), new HandRow()
        , new HandRow(), new HandRow(), new HandRow(), new HandRow()];
    public deckModel = new DeckModel();

    public isFiveRows = false;
    public isFiveColumns = false;
    public currentCard : CardModel = new CardModel(0);
    public isGameComplete = false;
    public isGameStarted = false;
    public deltCards = 0;
    public tabledCards = 0;
    public totalScore = 0;
    public options = new OptionModel();

    constructor() {
    }

    public get scoreText(): string {
        if (this.totalScore === 0) return 'Card game';
        return 'Total ' + this.totalScore.toString(); 
    }

    public setOptions() {
        this.repositionSquares();
        this.setAvailableSquares();
    }

    public newGame() {
        this.deckModel.shuffleCards();
        this.setNewGame();
        for (let y = 0; y < 6; y++) {
            for (let x = 0; x < 6; x++) {
                this.handRows[y].squares[x] = new SquareModel(y, x, 0);
            }
        }
        this.setAvailableSquares();
        this.dealCard();
    }

    private setNewGame()
    {
        this.deltCards = 0;
        this.totalScore = 0;
        this.tabledCards = 0;
        this.isFiveRows = false;
        this.isFiveColumns = false;
        this.isGameComplete = false;
        this.isGameStarted = true;
    }

    public get isUndoAllowed() {
        return (this.tabledCards > 1) && !this.isGameComplete;;
    }

    public replayGame() {
        this.deckModel.replayDeck();
        this.setNewGame();

        for (let y = 0; y < 6; y++) {
            for (let x = 0; x < 6; x++) {
                this.handRows[y].squares[x] = new SquareModel(y, x, 0);
            }
        }

        this.setAvailableSquares();
        this.dealCard();
    }

    public setNextSquare(row: number, col: number) {
        this.handRows[row].squares[col].cardModel.cardId = this.currentCard.cardId;
        this.handRows[row].squares[col].isAvailable = false;
        this.tabledCards++;

        if (this.tabledCards === 25) {
            this.calculateScore();
            this.isGameComplete = true;
            this.currentCard.cardId = 0;
        }
        else {
            if ((row === 0) || (row === 5) ||
            (col === 0) || (col === 5)) {
                this.repositionSquares();
            }
            this.setAvailableSquares();
            this.dealCard();
        }
    }

    public dealCard() : number {
        if (this.deltCards < 25) {
            this.currentCard.cardId = this.deckModel.dealCard();
            this.deltCards++;
            return this.currentCard.cardId;
        }
        else {
        }
        this.currentCard.cardId = 0;
        return 0;
    }

    public undoSquare() : number {
        let doReposition = false;
        if (this.deltCards > 2) {
            let lastCardId = this.deckModel.undoCard();

            for (let y = 0; y < 5; y++) {
                for (let x = 0; x < 5; x++) {
                    if (this.handRows[y].squares[x].cardModel.cardId === lastCardId) {
                        this.handRows[y].squares[x].cardModel.cardId = 0;
                        if ((y === 0) || (y >= 4))
                            doReposition = true;
                        if ((x === 0) || (x >= 4))
                            doReposition = true;
                    }
                }
            }

            this.deltCards--;
            this.tabledCards--;

            if (doReposition) {
                this.isFiveColumns = false;
                this.isFiveRows = false;
                this.repositionSquares();
            }

            this.setAvailableSquares();
            this.currentCard.cardId = this.deckModel.currentCardId;
        }
        return this.currentCard.cardId;
    }

    private calculateScore() {

        let totalScore = 0;
        for (let y = 0; y < 5; y++) {
            let hand = [this.handRows[y].squares[0].cardModel
                        , this.handRows[y].squares[1].cardModel
                        , this.handRows[y].squares[2].cardModel
                        , this.handRows[y].squares[3].cardModel
                        , this.handRows[y].squares[4].cardModel];
            this.calculateHand(hand, this.handRows[y].squares[5]);
            totalScore += this.handRows[y].squares[5].score;
        }
        for (let x = 0; x < 5; x++) {
            let hand = [this.handRows[0].squares[x].cardModel
                        , this.handRows[1].squares[x].cardModel
                        , this.handRows[2].squares[x].cardModel
                        , this.handRows[3].squares[x].cardModel
                        , this.handRows[4].squares[x].cardModel];
            this.calculateHand(hand, this.handRows[5].squares[x]);
            totalScore += this.handRows[5].squares[x].score;
        }
        this.totalScore = totalScore;
    }

    public calculateHand(cards : CardModel[], square: SquareModel) {
        let flushSuit = cards[0].cardSuitCode;
        let numberCounts = [0,0,0,0,0,0,0,0,0,0,0,0,0,0];
        let lowCard = 14;
        let hasAce = false;
        let highCard = 0;
        let isPair = false;
        let is2Pair = false;
        let is3Kind = false;
        let is4Kind = false;
        let isStraight = false;
        let isFlush = true;
        let score = 0;
        let scoreText = 'No match';

        for (let x = 0; x < 5; x++) {
            numberCounts[cards[x].cardNumber]++;
            if (flushSuit !== cards[x].cardSuitCode) isFlush = false;
            if (highCard < cards[x].cardNumber) highCard = cards[x].cardNumber;
            if (cards[x].cardNumber === 1) {
                hasAce = true;
            } else {
                if (lowCard > cards[x].cardNumber) lowCard = cards[x].cardNumber;
            }
            
        }

        if (hasAce) {
            if (highCard === 13 && lowCard === 10) isStraight = true;
            if (highCard === 5 && lowCard === 2) isStraight = true;
        }
        else {
            if (highCard - lowCard === 4) isStraight = true;
        }

        for (let x = 1; x < 14; x++) {
            if (numberCounts[x] === 4) {
                is4Kind = true;
            }
            if (numberCounts[x] === 3) {
                is3Kind = true;
            }
            if (numberCounts[x] === 2) {
                if (isPair) is2Pair = true;
                else isPair = true;
            }
        }

        if (is4Kind) {
            score = 50;
            scoreText = '4 of a kind';
        }
        else if (is2Pair) {
            score = 5;
            scoreText = '2 pair';
        }
        else if (isPair && is3Kind) {
            score = 25;
            scoreText = 'Full house';
        }
        else if (is3Kind) {
            score = 10;
            scoreText = '3 of a kind';
        }
        else if (isPair) {
            score = 2;
            scoreText = 'Pair';
        }
        else if (isStraight) {
            if (isFlush) {
                if (highCard === 13 && hasAce) {
                    score = 100;
                    scoreText = 'Royal flush';
                }
                else {
                    score = 75;
                    scoreText = 'Straight flush';
                }
            }
            else {
                score = 15;
                scoreText = 'Straight';
            }
        }
        else if (isFlush) {
            score = 20;
            scoreText = 'Flush';
        }
        square.score = score;
    }

    private repositionSquares() {

        if (this.isFiveRows && this.isFiveColumns) {
            return;
        }
        if (this.options.isEasyMode) {
            return;
        }

        let colStart = 2;
        let colEnd = 2;
        let rowStart = 2;
        let rowEnd = 2;
        for (let y = 0; y < 6; y++) {
            for (let x = 0; x < 6; x++) {
                if (this.handRows[y].squares[x].isCard) {
                    if (rowStart > y) { rowStart = y; }
                    if (rowEnd < y) { rowEnd = y; }
                    if (colStart > x) { colStart = x; }
                    if (colEnd < x) { colEnd = x; }
                }
            }
        }

        this.isFiveRows = ((rowEnd - rowStart) === 4);
        this.isFiveColumns = ((colEnd - colStart) === 4);

        if (colEnd === 5) {  // move hand left one square
            for (let y = 0; y < 6; y++) {
                for (let x = 0; x < 5; x++) {
                    this.handRows[y].squares[x].cardModel.cardId
                            = this.handRows[y].squares[x+1].cardModel.cardId;
                }
                this.handRows[y].squares[5].cardModel.cardId = 0;
            }
        } 
        else if ((colStart === 0) && !this.isFiveColumns) {  // move hand right one square
            for (let y = 0; y < 6; y++) {
                for (let x = 5; x > 0; x--) {
                    this.handRows[y].squares[x].cardModel.cardId 
                            = this.handRows[y].squares[x-1].cardModel.cardId;
                }
                this.handRows[y].squares[0].cardModel.cardId = 0;
            }
        }

        if (rowEnd === 5) {  // move hand up one square
            for (let x = 0; x < 6; x++) {
                for (let y = 0; y < 5; y++) {
                    this.handRows[y].squares[x].cardModel.cardId
                            = this.handRows[y+1].squares[x].cardModel.cardId;
                }
                this.handRows[5].squares[x].cardModel.cardId = 0;
            }
        }
        else if ((rowStart === 0) && !this.isFiveRows) {  // move hand down one square
            for (let x = 0; x < 6; x++) {
                for (let y = 5; y > 0; y--) {
                    this.handRows[y].squares[x].cardModel.cardId
                            = this.handRows[y-1].squares[x].cardModel.cardId;
                }
                this.handRows[0].squares[x].cardModel.cardId = 0;
            }
        }

    }

    public setAvailableSquares() {

        for (let y = 0; y < 6; y++) {
            for (let x = 0; x < 6; x++) {
                if (this.handRows[y].squares[x].isCard)
                    this.handRows[y].squares[x].isAvailable = false;
                else if (this.isFiveColumns && (x === 5)) 
                    this.handRows[y].squares[x].isAvailable = false;
                else if (this.options.isEasyMode && (x === 5)) 
                    this.handRows[y].squares[x].isAvailable = false;
                else if (this.isFiveRows && (y === 5))
                    this.handRows[y].squares[x].isAvailable = false;
                else if (this.options.isEasyMode && (y === 5))
                    this.handRows[y].squares[x].isAvailable = false;
                else if (this.options.isEasyMode) 
                    this.handRows[y].squares[x].isAvailable = true;                
                else 
                    this.handRows[y].squares[x].isAvailable = this.isAdjacientCard(y, x);                
            }
        }
        if (!this.handRows[2].squares[2].isCard) {  // allow for first card
            this.handRows[2].squares[2].isAvailable = true;
        }
    }

    private isAdjacientCard(row : number, col : number) {
        
        let result = false;

        if (row > 0) {
            if (this.handRows[row-1].squares[col].isCard) {
                result = true;
            }
        }
        if (row < 5) {
            if (this.handRows[row+1].squares[col].isCard) {
                result = true;
            }
        }

        if (col > 0) {
            if (this.handRows[row].squares[col-1].isCard) {
                result = true;
            }
        }
        if (col < 5) {
            if (this.handRows[row].squares[col+1].isCard) {
                result = true;
            }
        }

        return result;
    }

}
